let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("41AS9")).then(() => parcelRequire('f2agB'));